import React from 'react';
import classes from './Education.module.css';

const Education = ({ detailed }) => {
    return (
        <div className={classes.education__container}>
            <article className={classes.education__left}>
                {!detailed && <h3 className={classes.education__subtitle}>Course Structure</h3>}
                <h2 className={classes.education__title}>
                    <span className={classes.education__important_text}>StudyGroup</span> style teaching for your brighter future.
                </h2>
                <span className={classes.education__strong_text}>
                    Courses We Offered:
                </span>
                <ul>
                    <li>
                        <span className={classes.education__strong_text}>
                            Application of Computer
                        </span>
                        <div className={classes.course_elements_container}>
                            <div>Basics of computer</div>
                            <div>Word</div>
                            <div>Excel</div>
                            <div>Powerpoint</div>
                            <div>Basics of programming</div>
                            <div>Problem Solving techniques</div>
                            <div>Basics of web developement</div>
                        </div>
                    </li>
                    <br></br>
                    <li>
                        <span className={classes.education__strong_text}>
                            Javascript for Beginners
                        </span>
                        <div className={classes.course_elements_container}>
                            <div>Beyond the Basics</div>
                            <div>Hello Javascript</div>
                            <div>Variables</div>
                            <div>Conditional Statements</div>
                            <div>Dialog Boxes</div>
                            <div>Loops</div>
                            <div>Functions</div>
                            <div>Arrays</div>
                            <div>String</div>
                            <div>The Document Object</div>
                            <div>Dom manipulations</div>
                        </div>
                    </li>
                    <br></br>
                    <li>
                        <span className={classes.education__strong_text}>
                            Python Crash Course
                        </span>
                        <div className={classes.course_elements_container}>
                            <div>What is python</div>
                            <div>Installation of python</div>
                            <div>Features of python</div>
                            <div>Applications of python</div>
                            <div>Command line</div>
                            <div>Strings Class and Object</div>
                            <div>Constructors</div>
                            <div>Variables</div>
                            <div>Keywords</div>	
                            <div>Functions</div>
                            <div>Pass, Continue, Break</div>
                            <div>Data types</div>
                            <div>Operators</div>
                            <div>Dictionaries</div>
                            <div>Lists, Tuples, Sets</div>
                            <div>Encapsulation</div>
                            <div>Inheritance</div>		
                            <div>Polymorphism</div>
                            <div>Multi-Threading</div>
                            <div>Regular Expressions</div>
                            <div>Lambda functions</div>
                            <div>Python files</div>
                            <div>File Handling</div>
                            <div>If else</div>
                            <div>Loops</div>	
                            <div>Map, Filter, Reduce</div>	
                            <div>Modules</div>
                            <div>Generators</div>
                            <div>Decorators</div>
                            <div>overview Of Django</div>
                        </div>
                    </li>
                    <br></br>
                </ul>
                {/* <p>
                    For us, the{' '}
                    <span className={classes.education__strong_text}>primary reason to backtest is to determine profitability and risk.</span> How
                    good was the strategy's return historically? And how much did we risk to make that return? A backtest answers these questions
                    quite well.
                </p> */}
                {/* {!detailed && (
                    <a href='/blog' className={classes.education__btn}>
                        Learn More
                    </a>
                )} */}
            </article>
            <div className={classes.education1__right}>
                <figure className={classes.education1__figure}>
                    <img alt='Hero' src='groupstudy.png'/>
                </figure>
            </div>
        </div>
    );
};

export default Education;
